import { useCallback, useEffect, useState } from 'react';
import siteConfig from '../config/siteConfig';
import {
  applyConsent,
  initConsentMode,
  isGoogleAdsConfigured,
  readConsent,
  writeConsent
} from '../utils/consent';

export const OPEN_COOKIE_SETTINGS_EVENT = 'kfz:open-cookie-settings';

export function openCookieSettings() {
  window.dispatchEvent(new CustomEvent(OPEN_COOKIE_SETTINGS_EVENT));
}

function CookieConsent() {
  const { legal } = siteConfig;
  const [visible, setVisible] = useState(false);
  const adsConfigured = isGoogleAdsConfigured();

  useEffect(() => {
    initConsentMode();
    const existing = readConsent();
    if (existing) {
      applyConsent(existing.status);
    } else {
      setVisible(true);
    }

    const onOpen = () => setVisible(true);
    window.addEventListener(OPEN_COOKIE_SETTINGS_EVENT, onOpen);
    return () => window.removeEventListener(OPEN_COOKIE_SETTINGS_EVENT, onOpen);
  }, []);

  const decide = useCallback((status) => {
    writeConsent(status);
    applyConsent(status);
    setVisible(false);
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <div
      className="cookie-consent"
      role="dialog"
      aria-modal="false"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-desc"
    >
      <div className="cookie-consent-inner">
        <div className="cookie-consent-text">
          <h2 id="cookie-consent-title">Datenschutz-Einstellungen</h2>
          <p id="cookie-consent-desc">
            Wir setzen technisch notwendige Cookies ein, damit diese Website funktioniert.
            {adsConfigured
              ? ' Mit Ihrer Einwilligung nutzen wir zusätzlich Google Ads, um die Wirksamkeit unserer Werbung zu messen. Dabei werden Cookies gesetzt und Daten an Google übertragen.'
              : ''}{' '}
            Ihre Auswahl können Sie jederzeit über „Cookie-Einstellungen“ im Footer ändern. Mehr dazu in unserer{' '}
            <a href={legal.datenschutzUrl} target="_blank" rel="noopener noreferrer">
              Datenschutzerklärung
            </a>
            .
          </p>
        </div>
        <div className="cookie-consent-actions">
          <button
            type="button"
            className="btn btn-light cookie-btn-decline"
            onClick={() => decide('denied')}
          >
            Nur notwendige
          </button>
          <button
            type="button"
            className="btn btn-primary cookie-btn-accept"
            onClick={() => decide('granted')}
          >
            {adsConfigured ? 'Alle akzeptieren' : 'Verstanden'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
